import { Injectable, Injector } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from '../service/authentication.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private injector: Injector) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authService = this.injector.get(AuthenticationService);
    const token = authService.getToken();

    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    return next.handle(request).pipe(
      catchError((err) => {
        const isAuthError = err.status === 401 || err.status === 403;

        const message = (err.error?.message || '').toLowerCase();

        const isForcedLogout =
          message.includes('logged in from another device') || message.includes('session expired') || message.includes('token expired');

        if (isAuthError || isForcedLogout) {
          authService.Autologout();
        }

        return throwError(() => err);
      })
    );
  }
}
